import { Divider, Link, Typography } from "@mui/material";
import LoginForm from "./login-form";

const LoginLeftPanel = ({triggerLogin, requestAccess}: any) => {
    return (
        <div style={{ padding: "8px", textAlign: "center", display: "flex", flexDirection: "column", gap: "40px" }}>
            <Typography fontSize={"36px"} fontWeight={"600"}>Welcome to <br /> Connected vehicle - Data <br /> Analytics Dashboard</Typography>
            <div style={{
                padding: "24px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "40px",
            }}>
                <LoginForm />
                <Divider>
                    <Typography >{"OR"}</Typography>
                </Divider>
                <Typography>{'Don’t have an access? '}
                    <Link
                        component="button"
                        variant="body2"
                        onClick={requestAccess}
                        style={{
                            color: "black",
                            textDecorationColor: "black",
                            marginBottom: "4px"
                        }}
                    >
                        <Typography>{'Request Access'}</Typography>
                    </Link>
                </Typography>
            </div>
        </div>
    );
};

export default LoginLeftPanel;